$(function () {
    $("#about-modal-01").modaal({
        background: '#2C2C2C99',
        overlay_opacity: 0.6,
        hide_close: true,
        animation_speed: 0,
        after_callback_delay: 0
    });
    $('#about-close-01').click(function () {
        $('#about-modal-01').modaal('close');
    });

    $("#about-modal-02").modaal({
        background: '#2C2C2C99',
        overlay_opacity: 0.6,
        hide_close: true,
        animation_speed: 0,
        after_callback_delay: 0
    });
    $('#about-close-02').click(function () {
        $('#about-modal-02').modaal('close');
    });

    $("#about-modal-03").modaal({
        background: '#2C2C2C99',
        overlay_opacity: 0.6,
        hide_close: true,
        animation_speed: 0,
        after_callback_delay: 0
    });
    $('#about-close-03').click(function () {
        $('#about-modal-03').modaal('close');
    });

    $("#about-modal-04").modaal({
        background: '#2C2C2C99',
        overlay_opacity: 0.6,
        hide_close: true,
        animation_speed: 0,
        after_callback_delay: 0
    });
    $('#about-close-04').click(function () {
        $('#about-modal-04').modaal('close');
    });

    $("#about-modal-05").modaal({
        background: '#2C2C2C99',
        overlay_opacity: 0.6,
        hide_close: true,
        animation_speed: 0,
        after_callback_delay: 0
    });
    $('#about-close-05').click(function () {
        $('#about-modal-05').modaal('close');
    });
});